import index from './upload'
export default index